import { createApp } from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from './store';
import PrimeVue from 'primevue/config';

import Aura from '@primevue/themes/aura';
import Vue3Tour from 'vue3-tour';

import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@/assets/icons.js';

import 'leaflet/dist/leaflet.css';
import 'vue3-tour/dist/vue3-tour.css';
import '@/assets/css/app.css';

const app = createApp(App);

app.use(Vue3Tour);
app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: {
      darkModeSelector: 'false'
    }
  },
});

app.component('FontAwesomeIcon', FontAwesomeIcon);
app.component('FontAwesomeLayers', FontAwesomeLayers);
app.component('FontAwesomeLayersText', FontAwesomeLayersText);

app.use(store);

app.use(router);

app.mount('#app');
